import { render, staticRenderFns } from "./employment-doc-view.vue?vue&type=template&id=3c7f1366&scoped=true&"
import script from "./employment-doc-view.vue?vue&type=script&lang=js&"
export * from "./employment-doc-view.vue?vue&type=script&lang=js&"
import style0 from "./employment-doc-view.vue?vue&type=style&index=0&id=3c7f1366&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f1366",
  null
  
)

export default component.exports